import React, { useEffect, useRef, useState } from 'react';
import { getScrollParent } from '../../AIEmployees/useReveal';
import { Collapse } from 'antd';
import { Link } from 'react-router-dom';
import './LinearFAQ.css';

const FAQ_ITEMS = [
  {
    key: '1',
    label: 'Who pays for CellCog tasks triggered from Linear?',
    children: (
      <>
        The admin who installed the integration. Tasks consume credits from
        your CellCog account, shared across all your Linear workspace members.
        We chose this over per-user billing for zero-friction adoption; the
        tradeoff is that admins see concentrated usage.{' '}
        <Link to="/pricing">See pricing →</Link>
      </>
    ),
  },
  {
    key: '2',
    label: 'What can CellCog NOT do inside Linear?',
    children: (
      <>
        We&rsquo;re not a coding agent. We won&rsquo;t write production code,
        open pull requests, or review code. For that, Linear has Cursor, Devin,
        Factory, and more. CellCog handles everything else — research,
        documents, visual assets, dashboards, and data.
      </>
    ),
  },
  {
    key: '3',
    label: 'Can CellCog write back to Linear? Create comments, update issue status?',
    children: (
      <>
        Today: CellCog reads from Linear (via GraphQL) and publishes agent
        activities — thoughts, responses, and elicitations. Direct writes to
        the issue itself — comments, status changes, sub-issue creation — are
        coming in the next release.
      </>
    ),
  },
  {
    key: '4',
    label: "How is this different from Cursor or Devin's Linear integrations?",
    children: (
      <>
        Cursor and Devin are coding agents. Great at one job. CellCog is a
        multimodal agent — different job entirely. Both can coexist in the same
        Linear workspace: assign code tickets to <code>@Cursor</code>, assign
        everything else to <code>@CellCog</code>.
      </>
    ),
  },
  {
    key: '5',
    label: 'How do I disconnect, and what happens to active sessions?',
    children: (
      <>
        Disconnect from CellCog (<Link to="/delegate/linear">
          Delegate → Linear
        </Link>) OR from Linear&rsquo;s app settings. Either works — we revoke
        OAuth tokens on disconnect. Active agent sessions are errored cleanly
        so no Linear thread hangs.
      </>
    ),
  },
];

const LinearFAQ = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!ref.current) return undefined;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            io.disconnect();
          }
        });
      },
      { root: getScrollParent(ref.current), threshold: 0, rootMargin: '0px 0px 100% 0px' }
    );
    io.observe(ref.current);
    return () => io.disconnect();
  }, []);

  return (
    <section className="linear-faq section section-narrow" ref={ref}>
      <div className={`reveal ${visible ? 'is-visible' : ''}`}>
        <div className="linear-faq__header">
          <h2 className="section-title display-font">Questions people actually ask.</h2>
        </div>

        <Collapse
          items={FAQ_ITEMS}
          bordered={false}
          className="linear-faq__collapse"
          expandIconPosition="end"
          ghost
        />
      </div>
    </section>
  );
};

export default LinearFAQ;
